<!-- Apple-style Confirmation Dialog -->
<div class="apple-dialog-header">
  <div class="dialog-icon-wrapper warning">
    <mat-icon class="dialog-icon">warning</mat-icon>
  </div>
  <h2 class="apple-heading-3" mat-dialog-title>Coins verwenden?</h2>
</div>

<mat-dialog-content class="apple-dialog-content">
  <div class="confirmation-message">
    <p class="apple-body">
      Möchten Sie <span class="coins-highlight">{{ data.coins }} Coins</span> für diesen Auftrag wirklich verwenden?
    </p>
    <div class="apple-warning-card">
      <mat-icon class="warning-icon">info</mat-icon>
      <p class="apple-body-small">
        <strong>Hinweis:</strong> Diese Aktion kann nicht rückgängig gemacht oder geändert werden.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="apple-dialog-actions">
  <button class="apple-button apple-button-text" (click)="cancel()">
    <mat-icon>close</mat-icon>
    Abbrechen
  </button>
  <button
    class="apple-button apple-button-primary"
    (click)="useCoins()"
    cdkFocusInitial>
    <mat-icon>check_circle</mat-icon>
    Verwenden
  </button>
</mat-dialog-actions>
